import { tokens } from './active'

// Puts the active client's design tokens on :root before the first render.
// index.css keeps the default brand values as fallbacks for anything a brand does not set.
const applyTheme = (root = document.documentElement) => {
    Object.entries(tokens).forEach(([name, value]) => root.style.setProperty(name, value))
}

export default applyTheme
